var _defs, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZocoauditorias(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-2, .cls-3, .cls-4 {\r\n        fill: #b1c20e;\r\n      }\r\n\r\n      .cls-2 {\r\n        stroke-width: 4px;\r\n      }\r\n\r\n      .cls-2, .cls-3, .cls-5, .cls-4 {\r\n        stroke: #b1c20e;\r\n      }\r\n\r\n      .cls-2, .cls-3, .cls-4 {\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n      }\r\n\r\n      .cls-3 {\r\n        stroke-width: 3px;\r\n      }\r\n\r\n      .cls-6 {\r\n        fill: #b3c300;\r\n      }\r\n\r\n      .cls-5 {\r\n        fill: none;\r\n        stroke-miterlimit: 10;\r\n      }\r\n\r\n      .cls-4 {\r\n        stroke-width: .5px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 167.14,
    y: 201.75,
    width: 88.29,
    height: 12.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 167.14,
    y: 139.24,
    width: 88.29,
    height: 12.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 147.16,
    cy: 145.55,
    r: 7.31
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 147.16,
    cy: 208.07,
    r: 7.31
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 147.16,
    cy: 272.7,
    r: 7.31
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M235.7,84.4h-17.57c-.46,0-.84-.37-.84-.84v-.19c0-10.43-8.46-18.89-18.89-18.89s-18.89,8.46-18.89,18.89v.19c0,.46-.37.84-.84.84h-17.11c-1.72,0-3.12,1.4-3.12,3.12v5.15c0,8.9,7.21,16.11,16.11,16.11h48.15c8.9,0,16.11-7.21,16.11-16.11v-5.15c0-1.72-1.4-3.12-3.12-3.12ZM198.64,91.03c-4.53,0-8.21-3.67-8.21-8.21s3.67-8.21,8.21-8.21,8.21,3.67,8.21,8.21-3.67,8.21-8.21,8.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M192.59,266.39h-25.45v12.62h24.16c0-4.32.45-8.55,1.29-12.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M256.3,104.42h21.08s0,116.25,0,116.25c.42.15.82.31,1.21.47,4.33,1.27,8.51,2.98,12.48,5.11v-126.43c0-6.76-5.48-12.25-12.25-12.25h-22.52c-1.64,0-2.97,1.33-2.97,2.97v10.9c0,1.64,1.33,2.97,2.97,2.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M296.18,247.95c-19.95-19.95-52.3-19.95-72.25,0-19.95,19.95-19.95,52.3,0,72.25,17.64,17.64,44.97,19.67,64.86,6.11l41.57,41.57c3.9,3.9,10.22,3.9,14.11,0,3.9-3.9,3.9-10.22,0-14.11l-41.68-41.68c13.02-19.82,10.82-46.71-6.61-64.14ZM285.32,309.34c-13.95,13.95-36.58,13.95-50.54,0-13.95-13.95-13.95-36.58,0-50.54,13.95-13.95,36.58-13.95,50.54,0,13.95,13.95,13.95,36.58,0,50.54Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M247.17,304.8c-.88,0-1.76-.3-2.48-.91-.2-.17-.39-.34-.58-.51-10.55-9.53-11.37-25.86-1.85-36.4,1.42-1.57,3.86-1.7,5.43-.27,1.58,1.42,1.7,3.86.27,5.43-6.68,7.39-6.1,18.84,1.29,25.52.13.11.27.24.4.35,1.62,1.37,1.82,3.8.45,5.42-.76.9-1.85,1.36-2.94,1.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M247.17,304.8c-.88,0-1.76-.3-2.48-.91-.2-.17-.39-.34-.58-.51-10.55-9.53-11.37-25.86-1.85-36.4,1.42-1.57,3.86-1.7,5.43-.27,1.58,1.42,1.7,3.86.27,5.43-6.68,7.39-6.1,18.84,1.29,25.52.13.11.27.24.4.35,1.62,1.37,1.82,3.8.45,5.42-.76.9-1.85,1.36-2.94,1.36Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M203.7,317.69c-2.89-3.37-4.98-7.15-7.03-11.76h-75.79V104.41h18c1.64.01,2.98-1.32,2.98-2.96v-10.9c0-1.64-1.33-2.97-2.97-2.97h-20.43c-6.76,0-12.25,5.48-12.25,12.25v218.29c0,1.64,1.33,2.97,2.97,2.97h96.72c-.76-1.11-1.5-2.24-2.19-3.39Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M286.2,344.23c-4.45,1.94-9.06,3.35-13.74,4.25-21.89,10.73-46.48,16.76-72.46,16.76-91.11,0-165.24-74.12-165.24-165.24S108.89,34.76,200,34.76s165.23,74.12,165.23,165.23c0,42.71-16.29,81.69-42.98,111.05l16.52,16.52c30.91-33.6,49.82-78.42,49.82-127.57,0-103.99-84.6-188.6-188.6-188.6S11.4,96.01,11.4,200s84.6,188.6,188.6,188.6c37.17,0,71.87-10.82,101.11-29.46l-14.91-14.91Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZocoauditorias);
export default __webpack_public_path__ + "static/media/Zoco auditorias.c7f1b913ae0deb7366b15a803ad61b9f.svg";
export { ForwardRef as ReactComponent };